import api from './api';

export interface Score {
  id?: string;
  schoolId?: string;
  studentId: string;
  courseId: string;
  teacherId?: string;
  score: number; // 0-20 range
  examDate: string;
  creationDatetime?: string;
}

export interface ScoreInsertDTO {
  studentId: string;
  score: number;
}

export interface ScoreInsertRequest {
  classId: string;
  courseId: string;
  examDate: string;
  scores: ScoreInsertDTO[];
}

export interface BulletinRequest {
  studentId: string;
  startDate: string;
  endDate: string;
}

export interface BulletinCourse {
  courseId: string;
  courseName: string;
  factor: number;
  scores: number[];
  average: number;
}

export interface BulletinResponse {
  studentId: string;
  studentFirstName: string;
  studentLastName: string;
  startDate: string;
  endDate: string;
  courses: BulletinCourse[];
  weightedAverage: number;
}

export const scoreService = {
  getAllScores: async (): Promise<Score[]> => {
    const response = await api.get<Score[]>('/{schoolId}/scores');
    return response.data;
  },

  getScoresByStudent: async (studentId: string): Promise<Score[]> => {
    const response = await api.get<Score[]>(`/{schoolId}/scores/student/${studentId}`);
    return response.data;
  },

  getScoresByCourse: async (courseId: string): Promise<Score[]> => {
    const response = await api.get<Score[]>(`/{schoolId}/scores/course/${courseId}`);
    return response.data;
  },

  getScoreById: async (id: string): Promise<Score> => {
    const response = await api.get<Score>(`/{schoolId}/scores/${id}`);
    return response.data;
  },

  insertScoresBatch: async (request: ScoreInsertRequest): Promise<Score[]> => {
    const response = await api.post<Score[]>('/{schoolId}/scores/batch', request);
    return response.data;
  },

  updateScore: async (id: string, score: Score): Promise<Score> => {
    const response = await api.put<Score>(`/{schoolId}/scores/${id}`, score);
    return response.data;
  },

  deleteScore: async (id: string): Promise<void> => {
    await api.delete(`/{schoolId}/scores/${id}`);
  },

  generateBulletin: async (request: BulletinRequest): Promise<BulletinResponse> => {
    const response = await api.post<BulletinResponse>('/{schoolId}/scores/bulletin', request);
    return response.data;
  },
};


